
/* Un escapador al alcance de todos.
   El sitio define `esc` cinco veces, cada una encerrada en su IIFE, asi que
   desde el bloque del regalo no se alcanza ninguna. En vez de duplicar una
   sexta dentro de ese ambito, se deja una global con nombre propio. */
window.vEsc = function(s){
  return String(s == null ? "" : s).replace(/[&<>"']/g, function(c){
    return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c];
  });
};
